/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

(() => {
    const transitionClass = "js-page-transitioning";
    const unloadClass = "js-theme-unloading";
    const transitionDelay = 180;

    const ignoredProtocols = ["mailto:", "tel:", "sms:", "javascript:"];

    const shouldSkipTransition = (event, link, url) => {
        if (event.defaultPrevented || event.button !== 0) return true;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return true;
        if (link.classList.contains("js-no-transition") || link.hasAttribute("data-no-transition")) return true;
        if (link.hasAttribute("download")) return true;
        if (link.target && link.target.toLowerCase() !== "_self") return true;
        if (ignoredProtocols.includes(url.protocol)) return true;
        if (url.origin !== window.location.origin) return true;
        if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return true;
        return false;
    };

    const showPageTransition = () => {
        document.body.classList.add(transitionClass, unloadClass);
    };

    const hidePageTransition = () => {
        document.body.classList.remove(transitionClass, unloadClass);
    };

    document.addEventListener("click", (event => {
        const link = event.target.closest("a[href]");
        if (!link) return;

        const url = new URL(link.href, window.location.href);
        if (shouldSkipTransition(event, link, url)) return;

        event.preventDefault();
        showPageTransition();

        window.setTimeout((() => {
            window.location.href = url.href;
        }), transitionDelay);
    }));

    window.addEventListener("pageshow", hidePageTransition);
})();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map
